import { useRef, useState } from "react";
import { CaseStudyResponse } from "../../../data/caseStudies";
import { ECommerce, eCommerceHash } from "../ECommerce";
import { VRTechnology, vrTechHas } from "../VRTechnology";
import { MedicalSoftware, medicalSoftwareHash } from "../MedicalSoftware";
import { Container } from "react-bootstrap";
import { Finance, financeHash } from "../Finance";
import { useRouter } from "next/router";
import classes from "./CaseStudiesItems.module.scss";

const itemStyles = [
  {
    background: "#D9D9D9",
    color: "black",
  },
  {
    background: "#FEDF00",
    color: "black",
  },
  {
    background: "#239ED4",
    color: "white",
  },
  {
    background: "#5B5A5A",
    color: "white",
  },
];

type Props = {
  data: CaseStudyResponse;
};

const content = [
  <ECommerce key="ecommerce" />,
  <MedicalSoftware key="medicalsoftware" />,
  <VRTechnology key="vrtechnology" />,
  <Finance key="finance" />,
];

const studiesMapping = [
  eCommerceHash,
  medicalSoftwareHash,
  vrTechHas,
  financeHash,
];

export const CaseStudiesItemsMobile = ({ data }: Props) => {
  const router = useRouter();
  const containerRef = useRef<HTMLDivElement | null>(null);
  const selectedItem = router.asPath.split("#")[1];
  const openedItem = studiesMapping.findIndex((item) => item === selectedItem);
  const [openItems, setOpenItem] = useState<number[]>(
    openedItem != null ? [openedItem] : []
  );
  const caseStudies = data?.data;

  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView();
    }
  };

  const handleClick = (index: number) => {
    if (openItems.includes(index)) {
      setOpenItem((prevState) => prevState.filter((item) => item !== index));
    } else {
      setOpenItem((prevState) => [...prevState, index]);
    }
  };
  return (
    <div className="mb-6" ref={containerRef}>
      <div className={classes.arrowUp} onClick={scrollToTop}></div>
      {caseStudies
        .sort((cs, cs2) => cs.id - cs2.id)
        ?.map(({ attributes, id }, index) => {
          const isOpen = openItems.includes(index);
          return (
            <>
              <div
                key={id}
                onClick={() => handleClick(index)}
                className="py-6"
                style={itemStyles[index]}
              >
                <Container>
                  <h2
                    style={{ color: itemStyles[index].color, fontWeight: 500 }}
                    className="m-0 display-3"
                  >
                    {attributes.title}
                  </h2>
                </Container>
              </div>
              {isOpen && <div className="mt-6">{content[index]}</div>}
            </>
          );
        })}
    </div>
  );
};
